/* ==========================================================================
   FRESHFLOW - theme behaviour
   No dependencies. Progressive enhancement: every component works (or
   degrades to a plain link/form) if JS fails.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function money(cents) {
    if (window.FFCart && typeof window.FFCart.format === 'string') {
      var amount = (cents / 100).toFixed(2);
      return window.FFCart.format.replace('{{amount}}', amount).replace('{{ amount }}', amount);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------------------------------------------------------------- Reveal */
  function initReveal() {
    var items = $$('.ff-reveal:not(.is-in)');
    if (!items.length) return;
    if (REDUCED.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ----------------------------------------------------------- Scroll lock */
  var lockCount = 0;
  var savedScroll = 0;
  function lockScroll() {
    if (lockCount === 0) {
      savedScroll = window.scrollY;
      document.body.style.top = '-' + savedScroll + 'px';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.classList.add('ff-locked');
    }
    lockCount++;
  }
  function unlockScroll() {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.classList.remove('ff-locked');
      window.scrollTo(0, savedScroll);
    }
  }

  function trapFocus(container) {
    var sel = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var nodes = $$(sel, container).filter(function (n) { return n.offsetParent !== null; });
      if (!nodes.length) return;
      var first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    return function () { container.removeEventListener('keydown', onKey); };
  }

  /* --------------------------------------------------------------- Overlay */
  function overlay() {
    var el = $('#FfOverlay');
    if (!el) {
      el = document.createElement('div');
      el.id = 'FfOverlay';
      el.className = 'ff-overlay';
      el.setAttribute('aria-hidden', 'true');
      document.body.appendChild(el);
    }
    return el;
  }

  /* ---------------------------------------------------------------- Panels */
  var openPanels = [];

  function openPanel(el, opts) {
    if (!el || el.classList.contains('is-open')) return;
    opts = opts || {};
    el.classList.add('is-open');
    el.removeAttribute('aria-hidden');
    overlay().classList.add('is-open');
    lockScroll();
    var release = trapFocus(el);
    openPanels.push({ el: el, release: release, opener: document.activeElement, onClose: opts.onClose });
    window.setTimeout(function () {
      var focusTarget = el.querySelector('[data-ff-autofocus]') || el.querySelector('button, a[href], input');
      if (focusTarget) focusTarget.focus();
    }, 60);
  }

  function closePanel(el) {
    var idx = -1;
    for (var i = 0; i < openPanels.length; i++) { if (openPanels[i].el === el) { idx = i; break; } }
    if (idx === -1) return;
    var entry = openPanels.splice(idx, 1)[0];
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    entry.release();
    unlockScroll();
    if (!openPanels.length) overlay().classList.remove('is-open');
    if (entry.opener && typeof entry.opener.focus === 'function') entry.opener.focus();
    if (entry.onClose) entry.onClose();
  }

  function closeTopPanel() {
    if (openPanels.length) closePanel(openPanels[openPanels.length - 1].el);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') closeTopPanel();
  });

  document.addEventListener('click', function (e) {
    if (e.target === overlay()) closeTopPanel();
  });

  function initPanelTriggers() {
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-ff-open]');
      if (openBtn) {
        var target = document.getElementById(openBtn.getAttribute('data-ff-open'));
        if (target) { e.preventDefault(); openPanel(target); }
        return;
      }
      var closeBtn = e.target.closest('[data-ff-close]');
      if (closeBtn) {
        var panel = closeBtn.closest('.ff-mobilenav, .ff-drawer, .ff-search');
        if (panel) { e.preventDefault(); closePanel(panel); }
      }
    });
  }

  /* ---------------------------------------------------------- Announcement */
  function initAnnounce() {
    $$('[data-ff-announce]').forEach(function (root) {
      if (root.ffAnn) return;
      root.ffAnn = true;
      var slides = $$('.ff-announce__slide', root);
      if (slides.length < 2) return;
      var delay = parseInt(root.getAttribute('data-ff-announce'), 10) || 5000;
      var i = 0;
      window.setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, delay);
    });
  }

  /* ------------------------------------------------------------- Carousels */
  function initCarousels() {
    $$('[data-ff-carousel]').forEach(function (root) {
      if (root.ffCarousel) return;
      root.ffCarousel = true;
      var track = $('.ff-carousel__track', root);
      if (!track) return;
      var prev = $('[data-ff-prev]', root);
      var next = $('[data-ff-next]', root);
      var dotsWrap = $('[data-ff-dots]', root);
      var slides = Array.prototype.slice.call(track.children);

      function step() {
        var first = slides[0];
        if (!first) return track.clientWidth;
        var cs = getComputedStyle(track);
        var gap = parseFloat(cs.columnGap || cs.gap || '0');
        return first.getBoundingClientRect().width + (isNaN(gap) ? 0 : gap);
      }

      function move(dir) {
        track.scrollBy({ left: dir * step(), behavior: REDUCED.matches ? 'auto' : 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });

      var dots = [];
      if (dotsWrap && slides.length > 1) {
        dotsWrap.innerHTML = '';
        slides.forEach(function (_, idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ff-carousel__dot';
          b.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
          b.addEventListener('click', function () {
            track.scrollTo({ left: idx * step(), behavior: REDUCED.matches ? 'auto' : 'smooth' });
          });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }

      function sync() {
        var idx = Math.round(track.scrollLeft / Math.max(1, step()));
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }

      var raf;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(sync);
      }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ------------------------------------------------------------------ Tabs */
  function initTabs() {
    $$('[data-ff-tabs]').forEach(function (root) {
      if (root.ffTabs) return;
      root.ffTabs = true;
      var tabs = $$('[role="tab"]', root);
      var panels = $$('[role="tabpanel"]', root);
      if (!tabs.length) return;

      function select(idx, focus) {
        tabs.forEach(function (t, i) {
          var on = i === idx;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
          if (on && focus) t.focus();
        });
        panels.forEach(function (p, i) { p.hidden = i !== idx; });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i); });
        tab.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') n = 0;
          if (e.key === 'End') n = tabs.length - 1;
          if (n !== null) { e.preventDefault(); select(n, true); }
        });
      });
      select(0);
    });
  }

  /* ------------------------------------------------------------ Accordions */
  function initAccordions() {
    $$('[data-ff-acc-single]').forEach(function (group) {
      if (group.ffAcc) return;
      group.ffAcc = true;
      var items = $$('details.ff-acc__item', group);
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* -------------------------------------------------------------- Quantity */
  function initQty() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ff-qty]');
      if (!btn) return;
      e.preventDefault();
      var wrap = btn.closest('.ff-qty');
      var input = $('input', wrap);
      if (!input) return;
      var dir = btn.getAttribute('data-ff-qty') === 'up' ? 1 : -1;
      var min = parseInt(input.getAttribute('min'), 10);
      if (isNaN(min)) min = 1;
      var val = parseInt(input.value, 10);
      if (isNaN(val)) val = min;
      var next = Math.max(min, val + dir);
      if (next === val) return;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* --------------------------------------------------------------- Gallery */
  function initGallery() {
    $$('[data-ff-gallery]').forEach(function (root) {
      if (root.ffGallery) return;
      root.ffGallery = true;
      var slidesWrap = $('.ff-gallery__slides', root);
      var thumbs = $$('.ff-gallery__thumb', root);
      var dotsWrap = $('[data-ff-gallery-dots]', root);
      if (!slidesWrap) return;
      var slides = $$('.ff-gallery__slide', slidesWrap);

      function go(i) {
        slidesWrap.scrollTo({ left: i * slidesWrap.clientWidth, behavior: REDUCED.matches ? 'auto' : 'smooth' });
      }

      var dots = [];
      if (dotsWrap && slides.length > 1) {
        dotsWrap.innerHTML = '';
        slides.forEach(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ff-carousel__dot';
          b.setAttribute('aria-label', 'View image ' + (i + 1));
          b.addEventListener('click', function () { go(i); });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }

      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });

      function sync() {
        var i = Math.round(slidesWrap.scrollLeft / Math.max(1, slidesWrap.clientWidth));
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
      var raf;
      slidesWrap.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(sync);
      }, { passive: true });
      sync();

      root.addEventListener('ff:gallery:goto', function (e) {
        var id = e.detail && e.detail.mediaId;
        if (!id) return;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(id)) { go(i); break; }
        }
      });
    });
  }

  /* -------------------------------------------------------------- Variants */
  function initVariants() {
    $$('[data-ff-variants]').forEach(function (root) {
      if (root.ffVar) return;
      root.ffVar = true;
      var dataEl = $('[data-ff-variant-json]', root);
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
      var idInput = $('[data-ff-variant-id]', root);
      var priceNow = $('[data-ff-price-now]', root);
      var priceWas = $('[data-ff-price-was]', root);
      var submit = $('[data-ff-submit]', root);
      var stock = $('[data-ff-stock]', root);
      var gallery = $('[data-ff-gallery]', document);

      function selected() {
        return $$('[data-ff-option]', root)
          .filter(function (i) { return i.checked || i.tagName === 'SELECT'; })
          .map(function (i) { return i.value; });
      }

      function update() {
        var values = selected();
        var match = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var ok = true;
          for (var k = 0; k < values.length; k++) { if (v.options[k] !== values[k]) { ok = false; break; } }
          if (ok) { match = v; break; }
        }
        if (!match) {
          if (submit) { submit.disabled = true; submit.textContent = submit.getAttribute('data-unavailable') || 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceNow) priceNow.textContent = money(match.price);
        if (priceWas) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            priceWas.textContent = money(match.compare_at_price);
            priceWas.hidden = false;
          } else { priceWas.hidden = true; }
        }
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available
            ? (submit.getAttribute('data-add') || 'Add to cart')
            : (submit.getAttribute('data-soldout') || 'Sold out');
        }
        if (stock) {
          stock.textContent = match.available
            ? (stock.getAttribute('data-in') || 'In stock')
            : (stock.getAttribute('data-out') || 'Out of stock');
          stock.classList.toggle('ff-stock--out', !match.available);
        }
        if (gallery && match.featured_media_id) {
          gallery.dispatchEvent(new CustomEvent('ff:gallery:goto', { detail: { mediaId: match.featured_media_id } }));
        }
        if (window.history && window.history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', match.id);
            window.history.replaceState({}, '', url.toString());
          } catch (err) { /* noop */ }
        }
      }

      $$('[data-ff-option]', root).forEach(function (i) { i.addEventListener('change', update); });
      update();
    });
  }

  /* ------------------------------------------------------------------ Cart */
  var CART = {
    drawerId: 'FfCartDrawer',
    sectionId: 'ff-cart-drawer',

    drawer: function () { return document.getElementById(CART.drawerId); },

    setBusy: function (on) {
      var d = CART.drawer();
      if (d) d.classList.toggle('is-loading', !!on);
    },

    showError: function (msg) {
      var d = CART.drawer();
      if (!d) { window.alert(msg); return; }
      var box = $('[data-ff-cart-error]', d);
      if (!box) { window.alert(msg); return; }
      box.textContent = msg;
      box.classList.add('is-visible');
      window.setTimeout(function () { box.classList.remove('is-visible'); }, 6000);
    },

    updateCount: function (count) {
      $$('[data-ff-cart-count]').forEach(function (el) {
        el.textContent = count > 99 ? '99+' : String(count);
        el.hidden = count === 0;
      });
    },

    refresh: function (openAfter) {
      CART.setBusy(true);
      return fetch('/?sections=' + CART.sectionId)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data[CART.sectionId];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById(CART.drawerId);
          var current = CART.drawer();
          if (fresh && current) {
            var wasOpen = current.classList.contains('is-open');
            current.innerHTML = fresh.innerHTML;
            var c = fresh.getAttribute('data-cart-count');
            CART.updateCount(parseInt(c, 10) || 0);
            current.setAttribute('data-cart-count', c || '0');
            if (wasOpen) current.classList.add('is-open');
          }
          initCarousels();
        })
        .catch(function () { /* silent: /cart stays reachable */ })
        .then(function () {
          CART.setBusy(false);
          if (openAfter) openPanel(CART.drawer());
        });
    },

    add: function (formData, button) {
      var original = button ? button.innerHTML : null;
      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.innerHTML = '<span class="ff-spinner" aria-hidden="true"></span><span class="ff-sr">Adding</span>';
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            CART.showError((res.body && (res.body.description || res.body.message)) || 'This item could not be added.');
            return;
          }
          return CART.refresh(true);
        })
        .catch(function () { CART.showError('Something went wrong. Please try again.'); })
        .then(function () {
          if (button) {
            button.removeAttribute('aria-disabled');
            if (original !== null) button.innerHTML = original;
          }
        });
    },

    change: function (line, quantity, row) {
      if (row) row.classList.add('is-busy');
      CART.setBusy(true);
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return CART.refresh(false); })
        .catch(function () { CART.showError('We could not update your cart.'); CART.setBusy(false); });
    }
  };
  window.FFCartAPI = CART;

  function initCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-ff-add-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      CART.add(new FormData(form), btn);
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-ff-line-qty]');
      if (!input) return;
      var line = parseInt(input.getAttribute('data-ff-line-qty'), 10);
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      CART.change(line, qty, input.closest('.ff-citem, .ff-cartline'));
    });

    document.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-ff-line-remove]');
      if (!rm) return;
      e.preventDefault();
      CART.change(parseInt(rm.getAttribute('data-ff-line-remove'), 10), 0, rm.closest('.ff-citem, .ff-cartline'));
    });

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ff-cart-open]');
      if (!t) return;
      var d = CART.drawer();
      if (!d) return;
      e.preventDefault();
      openPanel(d);
    });
  }

  /* ------------------------------------------------------------ Sticky ATC */
  function initStickyAtc() {
    var bar = $('[data-ff-sticky-atc]');
    if (!bar) return;
    var anchor = $('[data-ff-atc-anchor]');
    if (!anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------------------------------------------------------------- Header */
  function initHeader() {
    var header = $('[data-ff-header]');
    if (!header) return;
    function setH() {
      document.documentElement.style.setProperty('--ff-header-h', header.offsetHeight / 10 + 'rem');
    }
    setH();
    window.addEventListener('resize', setH);
  }

  /* ------------------------------------------------------------------ Boot */
  function boot() {
    initPanelTriggers();
    initHeader();
    initAnnounce();
    initReveal();
    initCarousels();
    initTabs();
    initAccordions();
    initQty();
    initGallery();
    initVariants();
    initCart();
    initStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    initReveal(); initCarousels(); initTabs(); initAccordions();
    initGallery(); initVariants(); initStickyAtc(); initHeader(); initAnnounce();
  });
})();
